export const ds_GalleryBlock_Entry = `
    fragment ds_GalleryBlock_Entry on ds_GalleryBlock_Entry {
        id
        canonicalUid

        gallery_ContainerWidth
        gallery_ColorTheme
        gallery_ColorPalette
        gallery_TopSpacing
        gallery_FullWidthBackground

        gallery_Name
        gallery_GalleryType
        gallery_Images {
            url @transform(width: 1280, height: 720)
            alt
            focalPoint
        }
    }
`
